// CatchAllViewTypeButton.jsx

import React, { useState } from 'react';

// CSS
import './CatchAllViewTypeButton.css';
import './CatchAllViewTypeButtons.css';

// Icons
import Icon from 'svg/Icon';

/**
 * CatchAllViewTypeButton
 *
 * @returns {ReactNode} The rendered component.
 */
const CatchAllViewTypeButton = React.memo(({
    iconKey,
    isSelected,
    onClick,
    theme,
    title,
}) => {

    // ----- STATE ----- //

    const [hovered, setHovered] = useState(false);

    if (!iconKey) return null;
    // ----- RENDER ----- //

    return (
        <div
          className="catch-all-view-type-button"
          style={{
                backgroundColor: hovered ? theme.buttonHoverBackgroundColor : 'transparent',
            }}
          title={title}
          onClick={onClick}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
            <Icon
              iconKey={iconKey}
              width={20}
              height={20}
              color={isSelected ? (hovered ? theme.buttonHoverIconColor : theme.foreground) : hovered ? theme.buttonHoverLabelColor : theme.foregroundMuted}
            />
        </div>
    );
});

// Dev Tools
CatchAllViewTypeButton.displayName = 'CatchAllViewTypeButton';

export default CatchAllViewTypeButton;
